<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_478_235)">
      <circle cx="4" cy="4" r="3" stroke="currentColor" stroke-width="0.4" />
    </g>
    <defs>
      <clipPath id="clip0_478_235">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
